import React from 'react';
import { Server } from 'lucide-react';
import MasternodeStats from './MasternodeStats';
import MasternodeList from './MasternodeList';
import { useMasternodes } from '../../hooks/useMasternodes';

export default function MasternodesSection() {
  const { nodes, loading, error } = useMasternodes();

  return (
    <section id="masternodes" className="relative py-20">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(#1e293b_1px,transparent_1px)] [background-size:16px_16px] opacity-50" />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/95 via-slate-900/98 to-slate-900/95" />
      
      {/* Accent Lines */}
      <div className="absolute inset-0">
        <div className="h-px w-full bg-gradient-to-r from-transparent via-green-500/20 to-transparent" />
        <div className="absolute bottom-0 h-px w-full bg-gradient-to-r from-transparent via-green-500/20 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <Server className="h-10 w-10 text-green-500" />
            <h2 className="text-4xl font-bold">TWINS Masternodes</h2>
          </div>
          <p className="text-gray-400 max-w-3xl mx-auto">
            Masternodes are full nodes that secure the TWINS network, validate transactions, 
            and earn rewards. Operators can run nodes with collateral tiers of 1M, 5M, 20M, 
            or 100M TWINS.
          </p>
        </div>

        <div className="space-y-8">
          <MasternodeStats nodes={nodes} loading={loading} />
          <MasternodeList nodes={nodes} loading={loading} error={error} />
        </div>
      </div>
    </section>
  );
} 